var OCS = OCS || {};
OCS.Product = OCS.Product || {};
OCS.Product.Image = new Class({
    Extends: OCS.Product.Base,
    image_refresh_interval: null,
    image_updater: null,
    bound_methods: {},
    options: {
        product_class_name: 'Image',
        image_ops: {
            'image_loaded': Date.now() / 1000 | 0,
            'container_selector': ".container_selector",
            'refresh_image': false,
            'handle_sizing': true
        },
        image_unavailable_url: '/images/okfirst/image_unavailable.png',
        image_container_id: null, // Selector for the image
        refresh_time: 60000, // 1 min for every new image request
        src: ""


    },
    initialize: function (element, op) {
        if(!element) {
            return null;
        }
        this.parent(element, op);
        this.bound_methods.on_failed_image = this.on_failed_image.bind(this);
        this.bound_methods.on_new_image_available = this.on_new_image_available.bind(this);
        this.bound_methods.on_image_loaded = this.on_image_loaded.bind(this);
        this.options.src = element.get('src');


        if(!this.options.image_ops.container_selector) {
            this.options.image_ops.container_selector = element.selector;
        }

        //
        // var img_ops = {
        //     'image_loaded': Date.now() / 1000 | 0,
        //     'image_update_url': this.options.src,
        //     'image_update_frequency': this.options.refresh_time,
        //     'handle_sizing': true,
        //     container_selector: element.selector
        // };

        if(!this.options.image_ops.image_update_url) {
            this.options.image_ops.image_update_url = this.options.src;
        }
        if(!this.options.image_ops.image_update_frequency) {
            this.options.image_ops.image_update_frequency = this.options.refresh_time;
        }

        if (this.options.image_ops.image_update_frequency) {
            this.options.image_ops.refresh_image = true;
        }

        this.get_image();

    },
    on_image_loaded: function(image_obj) {
        image_obj.removeEvent('image_loaded', this.bound_methods.on_image_loaded);
        image_obj.update_image_size();
        image_obj.image_size_constrain();
    },
    on_new_image_available: function(image_obj) {
        image_obj.item.set('src', this.getCacheBustedUrl(image_obj.options.image_update_url, new Date().valueOf()));
    },
    on_failed_image: function (img_obj, resp) {
        if(resp.code === img_obj.options.error.codes.to_many_failures) {
            img_obj.item.set('src', this.options.image_unavailable_url);
            img_obj.fireEvent('stop_data_refresh');
        }
    },
    get_image: function() {
        if(!this.image_updater) {
            this.image_updater = new OCS.Classes.OCSImageObj(this.container, this.options.image_ops);
            this.image_updater.update_constraint_size();
            this.image_updater.addEvent('new_image_available', this.bound_methods.on_new_image_available);
            this.image_updater.addEvent('error', this.bound_methods.on_failed_image);
            this.image_updater.addEvent('image_loaded', this.bound_methods.on_image_loaded);
        }
        return this.image_updater;
    },
    getCacheBustedUrl: function(url, cache_buster) {
        var url_obj = new URI(url);
        url_obj.setData({'cache_bust': cache_buster}, true);
        return url_obj.toString();

    },
    resize: function () {
        this.image_updater.image_size_constrain();
    },
    destroy: function() {
        this.image_updater.removeEvent('new_image_available', this.bound_methods.on_new_image_available);
        this.image_updater.removeEvent('error', this.bound_methods.on_failed_image);
        this.image_updater.removeEvents();
        this.image_updater.destroy();
        this.parent();
    }
});